// Global Instructions Rule Applied!
import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faLayerGroup, faMagnifyingGlass, faUser } from '@fortawesome/free-solid-svg-icons'
import { MOBILE_ROUTES } from './lib/routes.ts'

const ITEMS = [
  { key: 'home', label: 'Home', path: MOBILE_ROUTES.home, icon: faHouse },
  { key: 'browse', label: 'Browse', path: MOBILE_ROUTES.browse, icon: faLayerGroup },
  { key: 'search', label: 'Search', path: MOBILE_ROUTES.search, icon: faMagnifyingGlass },
  { key: 'account', label: 'Account', path: MOBILE_ROUTES.account, icon: faUser }
]

/**
 * Which tab to highlight for a path. Browse list + any record-detail path keep Browse lit
 * (a detail belongs to a list); search/account/home light their own roots.
 */
function deriveActiveKey(pathname: string): string {
  if (pathname.startsWith('/account')) return 'account'
  if (pathname.startsWith('/search')) return 'search'
  if (
    pathname.startsWith('/browse') ||
    pathname.startsWith('/companies/') ||
    pathname.startsWith('/deals/') ||
    pathname.startsWith('/contacts/') ||
    pathname.startsWith('/funds/') ||
    pathname.startsWith('/fundraising/')
  ) {
    return 'browse'
  }
  return 'home'
}

/**
 * Fixed bottom tab bar (hand-rolled — Ant Design has no mobile TabBar; antd-mobile is
 * a separate package we don't pull in). Detail screens are pushed onto the history
 * stack from Search, so anything that isn't the Account tab keeps Search highlighted.
 */
export function MobileBottomNav(): React.JSX.Element {
  const navigate = useNavigate()
  const location = useLocation()
  const activeKey = deriveActiveKey(location.pathname)

  return (
    <nav
      className="safe-pb safe-pl safe-pr"
      style={{ position: 'sticky', bottom: 0, zIndex: 20, background: '#fff', borderTop: '1px solid #f0f0f0' }}
    >
      <div style={{ display: 'flex' }}>
        {ITEMS.map((item) => {
          const active = item.key === activeKey
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => navigate(item.path)}
              style={{
                flex: 1,
                border: 'none',
                background: 'transparent',
                padding: '8px 0 6px',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                color: active ? '#1890ff' : 'rgba(0,0,0,0.5)'
              }}
            >
              <FontAwesomeIcon icon={item.icon} style={{ fontSize: 18 }} />
              <span style={{ fontSize: 11 }}>{item.label}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default MobileBottomNav
